import {useCallback} from "react";
import {call} from "redux-saga/effects";
import {apiPost} from "./client";
import {useSagaCallback} from "../utils/sagas";

export const useAward = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, type) {
        return yield call(apiPost, `/api/v2/award/give.json`, {
            id,
            type,
        });
    }, []))
};